import getIsElFocusedById from '../../../../utils/getIsElFocusedById';
const handleKeyDownPropagation = ({ isOpen, name }) => (e) => {
    if (!getIsElFocusedById(name))
        return;
    // stop `esc` keydown bubbling for open (toggled on) select
    // (e.g. it might unexpectedly close the wrapping modal component)
    isOpen && e.which === 27 && e.stopPropagation();
};
export default handleKeyDownPropagation;
//# sourceMappingURL=handleKeyDownPropagation.js.map